import Avatar from '@/orm/models/AiInterview/Avatar';
import { ref } from '@vue/composition-api';

export default function useAvatars() {
  const avatars = ref();

  async function getAvatars() {
    const { response } = await Avatar.api().getAvatars();
    avatars.value = response.data.data;
  }

  return {
    avatars,
    getAvatars,
  };
}
